/* =====================================================================
   Langue, libelles et routes du site : window.FOG_I18N, window.FOG_ROUTES
   ---------------------------------------------------------------------
   Les donnees viennent de snippets/i18n-js.liquid (chaines rendues par le
   filtre `t`, routes Shopify avec prefixe de langue). Spec 07.

   FOG_I18N.t('cle')               -> libelle dans la langue de la page
   FOG_I18N.t('cle', { count: 3 }) -> remplace {{ count }} dans le libelle
   FOG_I18N.locale                 -> 'fr', 'en', 'de'... (Intl, dates)
   FOG_I18N.intl('fr-FR')          -> locale Intl a passer a Intl/toLocale* : en
                                      francais, celle donnee (inchangee) ; sinon
                                      de-DE, it-IT, en-GB, es-ES, ou la langue telle quelle
   FOG_ROUTES.root                 -> '/' ou '/en/' (toujours un / final)
   FOG_ROUTES.url('cart/add.js')   -> '/cart/add.js' ou '/en/cart/add.js'
   FOG_ROUTES.pages['sav']         -> URL de la page dans la langue courante, handle
                                      traduit compris (/de/pages/...) : a preferer a
                                      url('pages/x') pour toute page de contenu.

   Cle absente : on rend la cle elle-meme, visible en recette, plutot qu'un
   texte vide qui passerait inapercu.
   ===================================================================== */
(function () {
  var data = {};
  try {
    var el = document.getElementById('fog-i18n');
    if (el) data = JSON.parse(el.textContent);
  } catch (e) {}

  var strings = data.strings || {};
  var routes = data.routes || {};
  if (!routes.pages) routes.pages = {};
  if (!routes.root) routes.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  routes.url = function (chemin) {
    return routes.root + String(chemin || '').replace(/^\/+/, '');
  };

  /* Le filtre `t` rend un texte deja echappe pour le HTML : mesure du 15/10 sur
     la recette, « Erreur lors de l'ajout » arrive en « l&#39;ajout ». Les scripts
     ecrivent du texte (textContent), on decode donc une seule fois ici, avant de
     remplacer les variables. Un <textarea> decode les entites sans creer de
     balise ni executer quoi que ce soit. */
  function decode(s) {
    if (typeof s !== 'string' || s.indexOf('&') === -1) return s;
    var ta = document.createElement('textarea');
    ta.innerHTML = s;
    return ta.value;
  }

  /* Locale Intl par langue du site (dates, nombres, tri). Le francais garde
     exactement la locale de chaque script (fr-FR ou fr-CH), pour un rendu
     identique a l'existant. Spec 07, lot 6. */
  // Allemand et italien standard (decision du 16/10, spec 07 lot 8) : 1.794,25 comme le texte traduit.
  var INTL_PAR_LANGUE = { de: 'de-DE', it: 'it-IT', en: 'en-GB', es: 'es-ES' };

  window.FOG_ROUTES = routes;
  window.FOG_I18N = {
    locale: data.locale || document.documentElement.lang || 'fr',
    t: function (cle, vars) {
      var s = decode(strings[cle]);
      if (s == null) return cle;
      if (!vars) return s;
      return s.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, nom) {
        return vars[nom] != null ? String(vars[nom]) : m;
      });
    },
    intl: function (frLocale) {
      var locale = String(window.FOG_I18N.locale || 'fr');
      var langue = locale.toLowerCase().split('-')[0];
      if (langue === 'fr') return frLocale || 'fr';
      return INTL_PAR_LANGUE[langue] || locale;
    }
  };
})();
